import { render, staticRenderFns } from "./TextStat.vue?vue&type=template&id=61b4ef8b&scoped=true"
import script from "./TextStat.vue?vue&type=script&lang=js"
export * from "./TextStat.vue?vue&type=script&lang=js"
import style0 from "./TextStat.vue?vue&type=style&index=0&id=61b4ef8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4ef8b",
  null
  
)

export default component.exports